module.exports = __webpack_public_path__ + "mo/img/piece-09.cbe37542.svg";